module.exports = __webpack_public_path__ + "8d26532f3f9c572096674a5099d56a78.svg";